const TRUTHY_VALUES = ['true', 'new', 'b', 'enabled']

export const isExperimentOpen = (experimentsObj: Record<string, any>, experimentName: string) =>
	TRUTHY_VALUES.includes(`${experimentsObj[experimentName]}`.toLowerCase())
